import Vue from 'vue'
import {Card, Button, Dropdown, DropdownActionItem, ImageCard, Modal} from '@sportsrecruits/playbook';

const Components = {
  Card,
  Button,
  Dropdown,
  DropdownActionItem,
  ImageCard,
  Modal
}

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});

export const Colors = {
  green: "#1cb79e",
  blue: "#30a9de",
  red: "#DD544C",
  gray: "#f1f1f1",
  darkGray: "#dcdcdc",
  white: "#fff"
};
const lowBgHoverBorder = 'bg-transparent border-transparent';
export const dsColors = {
  white: {
    high: { text: 'text-white', bg: 'bg-transparent hover:bg-gray-800 border-transparent' },
    medium: { text: 'text-white', bg: 'bg-transparent hover:bg-gray-800 border border-solid border-white' },
    low: { text: 'text-white', bg: lowBgHoverBorder }
  },
  blueOnWhite: {
    high: { text: 'text-blue-300', bg: 'bg-white hover:bg-gray-100' },
    medium: { text: 'text-blue-300', bg: 'bg-white hover:bg-gray-100 border border-solid border-white' },
    low: { text: 'text-blue-300', bg: lowBgHoverBorder }
  },
  black: {
    high: { text: 'text-white', bg: 'bg-black hover:bg-gray-500 border-transparent' },
    medium: { text: 'text-black', bg: 'bg-transparent hover:bg-gray-100 border border-solid border-black' },
    low: { text: 'text-black', bg: lowBgHoverBorder }
  },
  gray: {
    high: { text: 'text-white', bg: 'bg-gray-300 hover:bg-gray-400 border-transparent' },
    medium: { text: 'text-gray-300', bg: 'bg-transparent hover:bg-gray-100 border border-solid border-gray-300' },
    low: { text: 'text-gray-300', bg: lowBgHoverBorder }
  },
  primary: {
    high: { text: 'text-white', bg: 'bg-blue-300 hover:bg-blue-400 border-transparent' },
    medium: { text: 'text-blue-300', bg: 'bg-transparent hover:bg-blue-100 border border-solid border-blue-300' },
    low: { text: 'text-blue-300', bg: lowBgHoverBorder }
  },
  success: {
    high: { text: 'text-white', bg: 'bg-green-300 hover:bg-green-400 border-transparent' },
    medium: { text: 'text-green-300', bg: 'bg-transparent hover:bg-green-100 border border-solid border-green-300' },
    low: { text: 'text-green-300', bg: lowBgHoverBorder }
  },
  warning: {
    high: { text: 'text-white', bg: 'bg-orange-300 hover:bg-orange-400 border-transparent' },
    medium: { text: 'text-orange-300', bg: 'bg-transparent hover:bg-orange-100 border border-solid border-orange-300' },
    low: { text: 'text-orange-300', bg: lowBgHoverBorder }
  },
  critical: {
    high: { text: 'text-white', bg: 'bg-red-300 hover:bg-red-400 border-transparent' },
    medium: { text: 'text-red-300', bg: 'bg-transparent hover:bg-red-100 border border-solid border-red-300' },
    low: { text: 'text-red-300', bg: lowBgHoverBorder }
  },
  teal: {
    high: { text: 'text-white', bg: 'bg-teal-300 hover:bg-teal-400 border-transparent' },
    medium: { text: 'text-teal-300', bg: 'bg-transparent hover:bg-teal-100 border border-solid border-teal-300' },
    low: { text: 'text-teal-300', bg: lowBgHoverBorder }
  },
  indigo: {
    high: { text: 'text-white', bg: 'bg-indigo-300 hover:bg-indigo-400 border-transparent' },
    medium: { text: 'text-indigo-300', bg: 'bg-transparent hover:bg-indigo-100 border border-solid border-indigo-300' },
    low: { text: 'text-indigo-300', bg: lowBgHoverBorder }
  }

}

export const dsTextSizes = {
  '2xs': 'ds-text-2xs',
  'xs': 'ds-text-xs',
  'sm': 'ds-text-sm',
  'md': 'ds-text-md',
  'lg': 'ds-text-lg',
  'xl': 'ds-text-xl',
  '2xl': 'ds-text-2xl',
  '3xl': 'ds-text-3xl',
  '4xl': 'ds-text-4xl',
  '5xl': 'ds-text-5xl',
  '6xl': 'ds-text-6xl',
  '7xl': 'ds-text-7xl',
  '8xl': 'ds-text-8xl'
}
